<template>
	<div class="container">
		<el-row style="height: 100%;position: relative;">
			<el-col :span="10" style="height: 100%;position: relative;">
				<div class="full">
					<div class="left_container full">
						<div class="title flex">部门列表</div>
						<template v-if="!multiple">
							<div class="list" style="border-bottom: 1px solid #d7dae2;height: 100%;">
								<department-tree :multiple="multiple" ref="selectdepartmenttree"
									@select="departmentTreeChange" />
							</div>
						</template>
						<template v-else>
							<div class="list" style="border-bottom: 1px solid #d7dae2;height: 360px;">
								<department-tree :multiple="multiple" ref="selectdepartmenttree"
									@select="departmentTreeChange" />
							</div>
							<div class="title flex">相对位置</div>
							<div class="list" style="height: 150px;">
								<div @click="relativepItemClick(item,index,$event)" class="relativep"
									:class="{relativep_active:item.active}" v-for="(item,index) in relativeP"
									:key="index">
									{{item.label}}
								</div>
							</div>
						</template>


					</div>
				</div>
			</el-col>
			<el-col :span="4" style="height: 100%;position: relative;">
				<div class="middle flex">
					<div>
						<el-button style="width: 50px;height: 50px;" type="primary" icon="el-icon-arrow-right" circle
							@click="toRight"></el-button>
					</div>
					<div style="margin-top: 50px;">
						<el-button style="width: 50px;height: 50px;" type="primary" icon="el-icon-arrow-left" circle
							@click="toLeft"></el-button>
					</div>
				</div>
			</el-col>
			<el-col :span="10" style="height: 100%;position: relative;">
				<div class="full">
					<div class="right_container full">
						<div class="title flex" style="flex-direction: row;">
							<div>
								选中列表
							</div>
							<div style="margin-left: 10px;cursor: pointer;" @click="data=[]">
								<i class="el-icon-delete"></i>
							</div>
						</div>
						<div class="list" style="height: 550px;">
							<div class="full" style="box-sizing: border-box;padding: 5px;" @click="clearDataItem">
								<div @click="dataItemClick(item,index,$event)" class="data" @dblclick="toLeft"
									:class="{data_active:item.active}" v-for="(item,index) in data" :key="index">
									{{item.departmentname}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>

</template>
<style scoped>
	.container {
		position: relative;
		width: 100%;
		height: 600px;
	}

	.middle {
		height: 100%;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.left_container {
		box-sizing: border-box;
		border: 1px solid #d7dae2;
	}

	.right_container {
		box-sizing: border-box;
		border: 1px solid #d7dae2;
	}

	.title {
		position: relative;
		width: 100%;
		height: 40px;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		font-size: 18px;

		background: rgb(244, 244, 245);
		border-bottom: 1px solid #d7dae2;
	}

	.list {
		position: relative;
		width: 100%;
		height: 410px;
		overflow: auto;
	}

	.relativep {
		cursor: pointer;
		user-select: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-o-user-select: none;
		-ms-user-select: none;
		-webkit-touch-callout: none;
		font-size: 14px;
		box-sizing: border-box;
		padding: 0px 4px;
		font-size: 14px;
	}

	.relativep_active {
		background-color: #409EFF;
		color: white;
	}

	.data {
		cursor: pointer;
		user-select: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-o-user-select: none;
		-ms-user-select: none;
		-webkit-touch-callout: none;
		font-size: 14px;
	}

	.data_active {
		background-color: #409EFF;
		color: white;
	}
</style>
<script>
	import departmentTree from '@_system/components/formcomponents/common/select/department/tree.vue'
	export default {
		props: {
			departmentid: {
				type: Array,
				default: () => {
					return []
				}
			},
			multiple: {
				type: Boolean,
				default: () => {
					return false
				}
			},
		},
		data() {
			return {
				currentdepartment: null,
				relativeP: [{
					label: '及其下级部门',
					type: 'children',
					active: false
				}],
				data: []

			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {
			this.initValue()
		},
		methods: {
			relativepItemClick(item, index, e) {
				e.stopPropagation()
				if (this.relativeP[index].active) {
					this.clearRelativep()
				} else {
					this.clearRelativep()
					this.relativeP[index].active = true
				}

			},
			clearRelativep() {
				this.relativeP.forEach((item) => {
					item.active = false
				})
			},
			initValue() {
				//console.log(this.departmentid)
				let id = []
				this.departmentid.forEach((item) => {
					if (Array.isArray(item)) {
						item.forEach((ele) => {
							id.push(ele)
							// if (Array.isArray(ele)) {
							// 	id.push(ele[ele.length - 1])
							// } else {
							// 	if (index == item.length - 1) {
							// 		id.push(ele)
							// 	}
							// }
						})

					} else {
						id.push(item)
					}
				})
				console.log(id)
				id.forEach((item) => {
					this.$refs.selectdepartmenttree.departmentsource.forEach((_item) => {
						if (_item.id == item) {
							let obj = {
								departmentid: _item.id,
								departmentname: _item.name,
								active: false
							}
							this.data.push(obj)
						}
					})
				})


			},
			departmentTreeChange(e) {
				this.currentdepartment = e
				//this.clearrelativep()
			},
			dataItemClick(item, index, e) {
				e.stopPropagation()
				this.clearDataItem()
				this.data[index].active = true
			},
			clearDataItem() {
				this.data.forEach((item) => {
					item.active = false
				})
			},
			getActiveDataItem() {
				let obj = null
				this.data.forEach((item, index) => {
					if (item.active) {
						obj = {
							item: item,
							index: index
						}
					}
				})
				return obj
			},
			checkDataItemUnique(checkItem) {
				let obj = null
				this.data.forEach((item) => {
					if (item.departmentid == checkItem.departmentid) {
						obj = true
					}
				})
				return obj
			},
			toRight() {
				if (!this.currentdepartment) {
					this.$message.error({
						message: '请选择部门',
					})
				} else {
					let obj = {
						departmentid: this.currentdepartment.id,
						departmentname: this.currentdepartment.name,
						active: false,
					}
					if (this.multiple) {
						let relativeP = this.relativeP.filter((item) => {
							return item.active
						})

						if (relativeP.length && relativeP[0].type == 'children') {
							let arr = this.selectAllChildren(this.currentdepartment)
							arr.forEach((item) => {
								let department = this.$refs.selectdepartmenttree.departmentsource.find((_item) => {
									return _item.id == item
								})
								let _obj = {
									departmentid: item,
									departmentname: department.name
								}
								if (!this.checkDataItemUnique(_obj)) {
									this.data.push(_obj)
								}
							})
						} else {
							if (!this.checkDataItemUnique(obj)) {
								this.data.push(obj)
							}
						}
					} else {
						if (this.data.length == 0) {
							if (!this.checkDataItemUnique(obj)) {
								this.data.push(obj)
							}
						} else {
							this.$message.error({
								message: '不可多选',
							})
						}
					}

					// else {
					// 	this.$message.error({
					// 		message: '该选项已存在',
					// 	})
					// }
				}
			},
			selectAllChildren(node) {
				let arr = []
				if (node.children && node.children.length > 0) {
					node.children.forEach(child => {
						arr.push(child)
						arr = arr.concat(this.selectAllChildren(child))
					});
				}
				return arr
			},

			toLeft() {
				let obj = this.getActiveDataItem()
				if (obj) {
					this.data.splice(obj.index, 1)
				}
			},
			submitData() {
				return this.data
			},
			setData(data) {
				data.forEach((item) => {
					item.active = false
				})
				this.data = data
			}
		},
		components: {
			departmentTree
		}
	}
</script>